import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';

import { LayoutComponent_Text as LegacyText } from 'ggApp/modules/layout';
import ggAuth from 'ggApp/modules/auth';
import ggRouter from 'ggApp/modules/router';
import { RedirectFlowStatus } from 'groverPaymentSDK';
import LocalLoader from 'ggApp/modules/layout/components/localLoader';
import { delayPromiseResolving } from 'ggApp/utils/promise';
import { Translator } from 'ggApp/modules/translator';
import { PaymentSdkContext } from '../state/paymentSdkContext';
import { getRedirectFlowDetails } from '../utils/didReceiveRedirect';
import { mapPollerErrorToTK, DEFAULT_ERROR } from './error';
import { StyledPaymentMessage } from './styles';

const mapStateToProps = createStructuredSelector({
    user: ggAuth.selectors.user,
    locationQuery: ggRouter.selectors.locationQuery,
});

const PaymentMethodPoller = ({ onPaymentMethodCreated, user, locationQuery }) => {
    const sdkInstance = useContext(PaymentSdkContext);
    const { status, paymentMethodTransaction } = getRedirectFlowDetails(locationQuery);
    const [paymentMethodCreationFailed, setPaymentMethodCreationError] = useState(null);
    const userId = user.id;
    useEffect(() => {
        if (status === RedirectFlowStatus.Failure) {
            sdkInstance
                .getPaymentMethod(userId, paymentMethodTransaction)
                .then((paymentMethod) => {
                    const { type } = paymentMethod;
                    setPaymentMethodCreationError(mapPollerErrorToTK({ type }));
                })
                .catch(() => {
                    setPaymentMethodCreationError(DEFAULT_ERROR);
                });
            return;
        }

        if (status === RedirectFlowStatus.Success) {
            // give user a chance to see the loading message
            // if the ensurePaymentMethod executes too fast
            delayPromiseResolving(
                sdkInstance.ensurePaymentMethod(userId, paymentMethodTransaction),
                1500,
            )
                .then(({ paymentMethodId, billingAccountId }) => {
                    onPaymentMethodCreated(paymentMethodId, billingAccountId);
                })
                .catch(() => {
                    setPaymentMethodCreationError(true);
                });
        }
    }, [onPaymentMethodCreated, sdkInstance, userId, status, paymentMethodTransaction]);

    if (paymentMethodCreationFailed) {
        return (
            <StyledPaymentMessage>
                <LegacyText>
                    <Translator tk="PAYMENT_METHOD_POLLER_DEFAULT_GATEWAY_ERROR" />
                </LegacyText>
            </StyledPaymentMessage>
        );
    }

    return (
        <StyledPaymentMessage>
            <LegacyText>
                <Translator tk="PAYMENT_METHOD_POLLER_LOADING" />
            </LegacyText>
            <LocalLoader active />
        </StyledPaymentMessage>
    );
};

PaymentMethodPoller.propTypes = {
    user: PropTypes.shape({
        id: PropTypes.number,
    }).isRequired,
    onPaymentMethodCreated: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(PaymentMethodPoller);
